"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPositionInfo = void 0;
function setPositionInfo(s, pos) {
    if (!pos)
        return;
    if (pos.x !== undefined)
        s.x = pos.x;
    if (pos.y !== undefined)
        s.y = pos.y;
    if (pos.width !== undefined)
        s.width = pos.width;
    if (pos.height !== undefined)
        s.height = pos.height;
    if (pos.anchor !== undefined) {
        if (typeof pos.anchor === "number")
            s.anchor.set(pos.anchor);
        else
            s.anchor.set(pos.anchor.x, pos.anchor.y);
    }
    if (pos.rotation !== undefined)
        s.rotation = pos.rotation;
    if (pos.scale !== undefined) {
        if (typeof pos.scale === "number")
            s.scale.set(pos.scale);
        else
            s.scale.set(pos.scale.x, pos.scale.y);
    }
}
exports.setPositionInfo = setPositionInfo;
//# sourceMappingURL=InfoType.js.map